import { injectable } from 'inversify';
import { ImportMode } from '../generated/types';
import { TranslationService } from '../services/translationService';
import { CsvInputService } from './csvInput';
import { MappableImportInputService } from './mappableImportInput';

@injectable()
export class PositionsImportInputService extends MappableImportInputService {
    static override IMPORT_COLUMNS_DEFAULT = {
        ...MappableImportInputService.IMPORT_COLUMNS_DEFAULT,

        /* CreateUpdate key */
        // TODO

        /* Required */
        PositionName: 'positionName',
        PositionCategoryName: 'positionCategoryName',
        SlotStart: 'slotStart',
        SlotEnd: 'slotEnd',
        MaxResources: 'slotMaxResources',

        /* Optional */
        SlotName: 'slotName',
        Acronym: 'acronym',
        Color: 'color',
        Icon: 'icon',
        Description: 'description',
        Address: 'address',
        Latitude: 'latitude',
        Longitude: 'longitude',
        MapLayer: 'mapLayer',
        MapZoom: 'mapZoom',
        LeadersEmails: 'leadersEmails',
        LeadersFirstNames: 'leadersFirstnames',
        LeadersLastNames: 'leadersLastnames',
        PrivateNote: 'privateNote',
        Tags: 'tags'
    };

    static override IMPORT_COLUMNS_REQUIRED = (mode: ImportMode) => [
        ...(mode === ImportMode.Update
            ? [PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.Id]
            : []),
        ...[
            PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.SlotStart,
            PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.SlotEnd,
            PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.MaxResources,
            PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.PositionName,
            PositionsImportInputService.IMPORT_COLUMNS_DEFAULT.PositionCategoryName
        ]
    ];

    // Needed to stop 'The number of constructor arguments in the derived class PositionsImportInputService must be >= than the number of constructor arguments of its base class' errors
    constructor(
        protected override csvInputService: CsvInputService,
        translationService: TranslationService
    ) {
        super(csvInputService, translationService);
    }
}
